export const CREDIT_OVERVIEW_API_CONFIG = {
  apiName: 'api-internal' as const,
  paths: {
    status: '/credit/status',
    summary: '/credit/report/summary',
    report: '/credit/report',
    invite: '/credit/invite',
  },
} as const;
